module.exports = __webpack_public_path__ + "img/icash-h.8607c774.svg";